var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 163,
    rx: 81.5,
    fill: "#FFC43D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6046 39.0395C67.275 31.3854 73.3913 25 81.0525 25V25C88.6975 25 94.8077 31.3595 94.5021 38.9983L92.2511 95.2727C92.2014 96.5169 91.1782 97.5 89.933 97.5H72.3443C71.1018 97.5 70.0799 96.5211 70.0264 95.2798L67.6046 39.0395Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 122,
    r: 14.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.e7a85251f314ac688384b4166873fc52.svg";
export { ForwardRef as ReactComponent };